// ProblemKids — same shape as Problem.jsx, framed for parents-to-be and new families.
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FmnWatermark } from "../FmnWatermark";

const FADE = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-80px" }, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } };

export function ProblemKids() {
    const { t } = useTranslation();
    return (
        <section
            className="relative py-32 px-6 bg-white overflow-hidden"
            data-testid="problem-kids-section"
            id="problem-kids"
        >
            <FmnWatermark position="right" size={700} opacity={0.05} rotate={8} />
            <div className="max-w-7xl mx-auto">
                <motion.p {...FADE} className="font-sans text-xs uppercase tracking-[0.3em] text-[#A85D62] font-semibold text-center mb-6">
                    {t("problem_kids.eyebrow")}
                </motion.p>
                <motion.h2
                    {...FADE}
                    transition={{ ...FADE.transition, delay: 0.1 }}
                    className="font-serif text-4xl sm:text-5xl lg:text-6xl text-center text-[#2D2B2A] max-w-3xl mx-auto leading-tight"
                >
                    {t("problem_kids.headline")}
                </motion.h2>

                <div className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-8 items-stretch">
                    <motion.div
                        {...FADE}
                        transition={{ ...FADE.transition, delay: 0.15 }}
                        className="md:col-span-4 rounded-3xl bg-[#FBF1F2] p-10 flex flex-col justify-center"
                        data-testid="problem-kids-stat-1"
                    >
                        <p className="font-serif text-6xl lg:text-7xl text-[#A85D62] tracking-tight">{t("problem_kids.stat_1_value")}</p>
                        <p className="mt-3 text-[#5C5A59] leading-relaxed">{t("problem_kids.stat_1_label")}</p>
                    </motion.div>
                    <motion.div
                        {...FADE}
                        transition={{ ...FADE.transition, delay: 0.25 }}
                        className="md:col-span-4 rounded-3xl bg-[#EAF2F9] p-10 flex flex-col justify-center"
                        data-testid="problem-kids-stat-2"
                    >
                        <p className="font-serif text-6xl lg:text-7xl text-[#3F6C99] tracking-tight">{t("problem_kids.stat_2_value")}</p>
                        <p className="mt-3 text-[#5C5A59] leading-relaxed">{t("problem_kids.stat_2_label")}</p>
                    </motion.div>
                    <motion.div
                        {...FADE}
                        transition={{ ...FADE.transition, delay: 0.35 }}
                        className="md:col-span-4 rounded-3xl bg-gradient-to-br from-[#E89AA1] to-[#A85D62] text-white p-10 flex flex-col justify-center"
                        data-testid="problem-kids-stat-3"
                    >
                        <p className="font-serif text-6xl lg:text-7xl tracking-tight">{t("problem_kids.stat_3_value")}</p>
                        <p className="mt-3 text-white/85 leading-relaxed">{t("problem_kids.stat_3_label")}</p>
                    </motion.div>
                </div>

                <motion.div
                    {...FADE}
                    transition={{ ...FADE.transition, delay: 0.45 }}
                    className="mt-20 max-w-3xl mx-auto text-center"
                    data-testid="problem-kids-body"
                >
                    <p className="text-xl text-[#2D2B2A] font-serif italic leading-relaxed">{t("problem_kids.quote")}</p>
                    <p className="mt-6 text-[#5C5A59] leading-relaxed">{t("problem_kids.body")}</p>
                </motion.div>
            </div>
        </section>
    );
}
